<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col
        class="text-center my-5">
        <p class="text-center font-weight-black display-4
              deep-orange--text text--lighten-2"
        >
          404
        </p>
        <p>Seems like that url doesn't exist.</p>
        <v-btn class="mt-5" color="success" to="/">
              Back to Home
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {

  name: 'NotFound',

  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
</style>
